import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactTable from 'react-table';
import { getFormValues } from 'redux-form';
import { has } from 'lodash';
import qs from 'qs';

import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { CycleMenuFieldEnum as Fields } from 'Common/FieldEnum';
import { TitledCard } from 'Components/';
import { MANAGE_CYCLE_MENUS_FORM_NAME } from 'Common/FormEnum';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import {
  errorToast,
  createToast,
  toastType,
  successToast,
} from 'Common/ToastHelper';

import * as Selector from '../state/listcycles/selectors';
import * as Actions from '../state/listcycles/actions';
import {
  MENU_OPTION_CYCLE_MENU_NEW,
  EDIT_MENU_QUERYSTRINGS,
  EDIT_MENU_TYPES,
} from '../helpers/Constants';
import { SharedMenusModal } from '../components/SharedMenusModal';

class CycleMenuListContainer extends Component {
  state = {
    showDeleteModal: false,
    deleteMenuId: null,
    deleteMenuName: null,
    showDuplicateModal: false,
    duplicateMenuId: null,
    duplicateMenuName: null,
    showSharedMenusModal: false,
    sharedMenuDescription: null,
    sharedCycleMenuId: null,
  };

  onEditMenuClick = (row) => {
    const { history } = this.props;
    const queryParams = {
      [EDIT_MENU_QUERYSTRINGS.VIEW]: EDIT_MENU_TYPES.CYCLE_MENU,
    };
    const queryString = qs.stringify(queryParams);

    history.push(`/managemenu/edit/${row.Id}?${queryString}`);
  };

  onDuplicateMenuClick = (row) => {
    const { showAddButtonAndMenuNav } = this.props;

    showAddButtonAndMenuNav(false);

    this.setState({
      duplicateMenuId: row.Id,
      duplicateMenuName: row.Description,
      showDuplicateModal: true,
    });
  };

  handleDuplicateMenuDialog = (result) => {
    const { onMenuChange, duplicateCycleMenu } = this.props;
    const { duplicateMenuId } = this.state;

    this.setState({ showDuplicateModal: false });
    if (result) {
      duplicateCycleMenu(duplicateMenuId).then((result) => {
        if (result) {
          this.onDuplicateComplete();
          createToast(
            toastType.success,
            'Success',
            'Menu Duplicated Successfully.',
            true
          );
          onMenuChange(MENU_OPTION_CYCLE_MENU_NEW);
        }
      });
    } else {
      this.onDuplicateComplete();
    }
  };

  onDuplicateComplete = () => {
    this.setState({
      duplicateMenuId: null,
      duplicateMenuName: null,
    });
  };

  onDeleteMenuClick = (row) => {
    this.setState({
      deleteMenuId: row.Id,
      deleteMenuName: row.Description,
      showDeleteModal: true,
    });
  };

  handleDeleteMenuDialog = (result) => {
    const { deleteCycleMenu } = this.props;
    const { deleteMenuId } = this.state;
    if (result) {
      deleteCycleMenu(deleteMenuId).then(() => {
        this.onDeleteComplete();
        this.props.loadMenuList();
      });
    } else {
      this.onDeleteComplete();
    }
  };

  onDeleteComplete = () => {
    this.setState({
      deleteMenuId: null,
      deleteMenuName: null,
      showDeleteModal: false,
    });
  };

  onShareClick = (row) => {
    this.setState({
      showSharedMenusModal: true,
      sharedMenuDescription: row.Description,
      sharedCycleMenuId: row.Id,
    });
  };
  onShareModalClose = () => {
    this.setState({
      showSharedMenusModal: false,
      sharedMenuDescription: null,
    });
  };

  onShare = (cycleMenuId, selectedDistricts) => {
    const { shareCycleMenu } = this.props;

    shareCycleMenu({
      CycleMenuId: cycleMenuId,
      DistrictIds: selectedDistricts,
    });
  };

  onUnshare = (cycleMenuId, selectedDistricts) => {
    const { unshareCycleMenu } = this.props;

    unshareCycleMenu({
      CycleMenuId: cycleMenuId,
      DistrictIds: selectedDistricts,
    });
  };

  handleModalOpen = () => {
    const { getSharedDistricts } = this.props;
    const { sharedCycleMenuId } = this.state;

    getSharedDistricts({ CycleMenuId: sharedCycleMenuId });
  };

  columns = [
    {
      Header: 'Description',
      accessor: Fields.Description,
      filterable: true,
      resizable: false,
    },
    {
      Header: 'Nutrition Standard',
      accessor: Fields.NutritionStandard,
      filterable: true,
      width: 200,
      resizable: false,
    },
    {
      Header: 'Days In Cycle',
      accessor: Fields.NumberOfDaysInCycle,
      filterable: true,
      width: 100,
      style: { textAlign: 'right' },
      resizable: false,
    },
    {
      Header: 'Fiscal Year',
      accessor: Fields.FiscalYear,
      filterable: true,
      width: 100,
      style: { textAlign: 'right' },
      resizable: false,
    },
    {
      Header: 'Servings',
      accessor: Fields.Servings,
      filterable: true,
      width: 100,
      style: { textAlign: 'right' },
      resizable: false,
    },
    {
      Header: 'Analysis Days',
      accessor: Fields.AnalysisDays,
      filterable: true,
      width: 100,
      style: { textAlign: 'right' },
      resizable: false,
    },
    {
      Header: 'Source',
      accessor: Fields.SharedSource,
      filterable: true,
      width: 200,
      style: { textAlign: 'left' },
      resizable: true,
    },
    {
      width: 40,
      sortable: false,
      resizable: false,
      style: { textAlign: 'center' },
      Cell: (gridProps) =>
        GridContextMenu({
          gridProps,
          options: this.props.isParentDistrict
            ? this.menuOptions
            : this.menuOptionsWithoutShareOption,
        }),
    },
  ];

  menuOptionsWithoutShareOption = [
    {
      icon: 'eye',
      text: 'View',
      handler: this.onEditMenuClick,
      disabledWhen: (x) => !this.props.isReadOnly && !x.IsReadOnly,
    },
    {
      icon: 'pencil',
      text: 'Edit',
      handler: this.onEditMenuClick,
      disabledWhen: (x) => this.props.isReadOnly || x.IsReadOnly,
    },
    {
      icon: 'copy',
      text: 'Duplicate',
      handler: this.onDuplicateMenuClick,
      disabledWhen: (x) => this.props.isReadOnly || x.IsReadOnly,
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: this.onDeleteMenuClick,
      disabledWhen: (x) =>
        this.props.isReadOnly || x.Active === 'N' || x.IsReadOnly,
    },
  ];

  menuOptions = [
    {
      icon: 'eye',
      text: 'View',
      handler: this.onEditMenuClick,
      disabledWhen: (x) => !this.props.isReadOnly && !x.IsReadOnly,
    },
    {
      icon: 'pencil',
      text: 'Edit',
      handler: this.onEditMenuClick,
      disabledWhen: (x) => this.props.isReadOnly || x.IsReadOnly,
    },
    {
      icon: 'copy',
      text: 'Duplicate',
      handler: this.onDuplicateMenuClick,
      disabledWhen: (x) => this.props.isReadOnly || x.IsReadOnly,
    },
    {
      icon: 'share',
      text: 'Share',
      handler: this.onShareClick,
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: this.onDeleteMenuClick,
      disabledWhen: (x) =>
        this.props.isReadOnly || x.Active === 'N' || x.IsReadOnly,
    },
  ];

  getTrProps = (state, rowInfo, column) => {
    return {
      style: {
        color:
          has(rowInfo, 'original.Active') && rowInfo.original.Active !== 'Y'
            ? 'red'
            : '',
      },
    };
  };

  componentDidMount() {
    const { getIsParentDistrict } = this.props;
    getIsParentDistrict();
  }

  componentDidUpdate(prevProps) {
    const {
      clearErrors,
      setShareSuccessful,
      setUnshareSuccessful,
    } = this.props;

    if (
      successToast(
        this.props,
        prevProps,
        'shareSuccessful',
        'Cycle Menu Has Been Queued to Share.'
      )
    ) {
      this.onShareModalClose();

      setShareSuccessful(false);
    }

    if (
      successToast(
        this.props,
        prevProps,
        'unshareSuccessful',
        'Cycle Menu Has Been Queued to Unshare.'
      )
    ) {
      this.onShareModalClose();

      setUnshareSuccessful(false);
    }

    if (
      errorToast(this.props, prevProps, 'shareError') ||
      errorToast(this.props, prevProps, 'fetchSharedDistrictsError') ||
      errorToast(this.props, prevProps, 'unshareError')
    ) {
      clearErrors();
    }
  }

  render() {
    const { gridData, fetching, sharedDistricts } = this.props;
    const {
      showDeleteModal,
      deleteMenuName,
      showDuplicateModal,
      duplicateMenuName,
      showSharedMenusModal,
      sharedMenuDescription,
      sharedCycleMenuId,
    } = this.state;

    return (
      <Fragment>
        <TitledCard title={'Cycle Menus'}>
          <ReactTable
            columns={this.columns}
            data={gridData || []}
            loading={fetching}
            minRows={5}
            showPageSizeOptions={false}
            defaultFilterMethod={caseInsensitiveFilter}
            getTrProps={this.getTrProps}
            defaultSorted={[
              {
                id: Fields.FiscalYear,
                desc: true,
              },
              {
                id: Fields.Description,
              },
            ]}
          />
        </TitledCard>
        <YesNoDialog
          showDialog={showDeleteModal}
          title={`Delete Cycle Menu`}
          question={` Are you sure you want to delete ${deleteMenuName}?`}
          yesCallback={() => {
            this.handleDeleteMenuDialog(true);
          }}
          noCallback={() => {
            this.handleDeleteMenuDialog(false);
          }}
        />
        <YesNoDialog
          showDialog={showDuplicateModal}
          title={`Duplicate Cycle Menu`}
          question={` Are you sure you want to duplicate ${duplicateMenuName}?`}
          yesCallback={() => {
            this.handleDuplicateMenuDialog(true);
          }}
          noCallback={() => {
            this.handleDuplicateMenuDialog(false);
          }}
        />
        <SharedMenusModal
          showSharedMenusModal={showSharedMenusModal}
          sharedItemDescription={sharedMenuDescription}
          sharedItemId={sharedCycleMenuId}
          sharedDistricts={sharedDistricts}
          onShare={this.onShare}
          onUnshare={this.onUnshare}
          handleOpen={this.handleModalOpen}
          onShareModalClose={this.onShareModalClose}
          loading={fetching}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    gridData: Selector.getGridData(state),
    fetchSharedDistrictsError: Selector.getFetchSharedDistrictsError(state),
    shareError: Selector.getShareError(state),
    unshareError: Selector.getUnshareError(state),
    fetching: Selector.getFetching(state),
    fetchError: Selector.getFetchError(state),
    formValues: getFormValues(MANAGE_CYCLE_MENUS_FORM_NAME)(state) || {},
    sharedDistricts: Selector.getSharedDistrictsForSelectSitesTable(state),
    shareSuccessful: Selector.getShareSuccessful(state),
    unshareSuccessful: Selector.getUnshareSuccessful(state),
    isParentDistrict: Selector.getIsParentDistrict(state),
  };
};

const mapDispatchToProps = {
  getFormValues,
  ...Actions,
};

export const CycleMenuList = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CycleMenuListContainer)
);



// WEBPACK FOOTER //
// ./src/pages/managemenu/tabs/CycleMenuList.js